import { IRequestConfig } from "angular";
import { appModule } from "../../app/app-module";
import { utilsModule } from "../utils-module";
import APP_VERSION from "../../../appVersion";

utilsModule.factory('appVersionInterceptor', [
    '$state','$rootScope','$q',
function ($state,$rootScope:any,$q:any) {

    let exceptionHosts:string[] = [
        'apps.widenet.com.br'
    ];

    let shouldIntercept = function(url:string){
        for (var i in exceptionHosts){
            var host = exceptionHosts[i];
            if (url.indexOf(host) > -1){
                return false;
            }
        }
        return true;
    }

    return {
        request: function(config:IRequestConfig) {
            if(shouldIntercept(config.url)){
                config.headers['appVersion'] = APP_VERSION
            }
            return config;
        },
        responseError: function(rejection){
            if(rejection.status == 400){
                if(rejection.data && rejection.data.error && (rejection.data.error.message == 'OUTDATED_APP')){                    
                    $rootScope.$broadcast("outdated-app")
                }
            }
            return $q.reject(rejection)
        }
    }
}]);